<template>
  <div>
    <v-btn
      x-small
      :disabled="carregando"
      v-if="item.boleto == 1 && item.boleto_token"
      class="btn highlighted-as-forward mr-1"
      @click="handleBoletoSegundaVia(item)"
    >
      <i class="fas fa-barcode mr-1"></i> 2ª via
    </v-btn>
    <v-btn
      x-small
      :disabled="carregando"
      v-if="
        item.id &&
        item.finance_client_id &&
        item.boleto == 0 &&
        item.finance_configuration_account_boleto_token
      "
      class="btn highlighted-as-forward mr-1"
      @click="handleModalBoleto(item)"
    >
      <i class="fas fa-barcode"></i> Emitir
    </v-btn>

    <b-modal
      scrollable
      size="md"
      no-close-on-backdrop
      hide-footer
      centered
      :id="`boleto-${item.finance_launch_bills_to_pay_id}-${item.id}`"
      modal-class="boleto-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-boleto">
          <i class="fas fa-barcode mr-2"></i>
          Gerar Boleto
        </div>
      </template>

      <div class="boleto-content">
        <!-- Botão Gerar -->
        <v-btn
          v-if="!resultado || !resultado.sucesso"
          @click="criarBoleto"
          :disabled="carregando"
          class="btn highlighted-as-forward btn-block"
        >
          <i class="fas fa-plus-circle mr-2"></i>
          {{ carregando ? "Gerando..." : "Gerar Boleto" }}
        </v-btn>

        <!-- Resultado -->
        <div v-if="resultado" class="resultado-section">
          <!-- Sucesso -->
          <div v-if="resultado.sucesso" class="resultado-sucesso">
            <div class="sucesso-header">
              <i class="fas fa-check-circle success-icon"></i>
              <h4 class="success-title">Boleto emitido com sucesso!</h4>
            </div>

            <div class="acoes-boleto">
              <button @click="baixarBoleto" class="btn-acao btn-baixar">
                <i class="fas fa-download mr-1"></i>
                Baixar PDF
              </button>
              <button @click="visualizarBoleto" class="btn-acao btn-visualizar">
                <i class="fas fa-eye mr-1"></i>
                Visualizar PDF
              </button>
            </div>
          </div>

          <!-- Erro -->
          <div v-else class="resultado-erro">
            <div class="erro-header">
              <i class="fas fa-exclamation-triangle error-icon"></i>
              <h4 class="error-title">Erro ao gerar boleto</h4>
            </div>
            <div class="erro-details">
              <p><strong>Código HTTP:</strong> {{ resultado.codigoHttp }}</p>
              <div class="erro-content">
                <pre>{{ JSON.stringify(resultado.erro, null, 2) }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import {
  gerarBoleto,
  baixarPDF,
  visualizarPDF,
} from "../../../../services/boletocloud/api";

import { formatValueOnKeyUp } from "../../../../lib/format";

export default {
  name: "BoletoGenerator",
  data() {
    return {
      carregando: false,
      resultado: null,
      pdfBlob: null,
    };
  },

  props: {
    item: Object,
  },

  methods: {
    gerarBoleto,
    formatValueOnKeyUp,

    handleModalBoleto(item) {
      this.$bvModal.hide(`action-${item.id}`);
      this.$bvModal.show(
        `boleto-${item.finance_launch_bills_to_pay_id}-${item.id}`
      );
    },

    handleBoletoSegundaVia(item) {
      window.open(
        `https://app.boletocloud.com/boleto/2via/${item.boleto_token}`,
        "_blank"
      );
    },

    async criarBoleto() {
      try {
        this.carregando = true;
        this.resultado = null;

        let { id, due_date, totalCredito } = this.item;

        totalCredito = formatValueOnKeyUp(String(totalCredito));

        totalCredito = String(totalCredito)
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(".", "")
          .replace(",", ".");

        const dadosPersonalizados = {
          id,
          emissao: moment().format("YYYY-MM-DD"),
          vencimento: moment(due_date).format("YYYY-MM-DD"),
          titulo: "DM",
          valor: totalCredito,
          instrucoes: [],
        };

        const resultado = await gerarBoleto(dadosPersonalizados);

        this.resultado = resultado;

        if (resultado.sucesso) {
          this.pdfBlob = resultado.pdf;
        }

        this.$emit("gerado", true);

        this.carregando = false;
      } catch (error) {
        this.carregando = false;
        this.resultado = { sucesso: false, erro: error.message };
      }
    },

    baixarBoleto() {
      if (this.pdfBlob) {
        baixarPDF(this.pdfBlob, "meu-boleto.pdf");
      }
    },

    visualizarBoleto() {
      if (this.pdfBlob) {
        visualizarPDF(this.pdfBlob);
      }
    },

    calcularVencimento(dias) {
      const data = new Date();
      data.setDate(data.getDate() + dias);
      return data.toISOString().split("T")[0];
    },
  },
};
</script>

<style scoped>
/* Modal Title */
.modal-title-boleto {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

/* Content */
.boleto-content {
  padding: 8px 0;
}

/* Botão Gerar */
.btn-gerar-boleto {
  width: 100%;
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(78, 145, 48, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-gerar-boleto:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(78, 145, 48, 0.4);
}

.btn-gerar-boleto:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Resultado Section */
.resultado-section {
  margin-top: 20px;
}

/* Sucesso */
.resultado-sucesso {
  background: #f0f9f0;
  border: 1px solid #4caf50;
  border-radius: 8px;
  padding: 20px;
}

.sucesso-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  text-align: center;
  justify-content: center;
}

.success-icon {
  color: #4caf50;
  font-size: 24px;
  margin-right: 8px;
}

.success-title {
  color: #2e7d32;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.acoes-boleto {
  display: flex;
  gap: 12px;
}

.btn-acao {
  flex: 1;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-baixar {
  background: #28a745;
  color: white;
}

.btn-baixar:hover {
  background: #218838;
  transform: translateY(-1px);
}

.btn-visualizar {
  background: #17a2b8;
  color: white;
}

.btn-visualizar:hover {
  background: #138496;
  transform: translateY(-1px);
}

/* Erro */
.resultado-erro {
  background: #fdf2f2;
  border: 1px solid #f87171;
  border-radius: 8px;
  padding: 20px;
}

.erro-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.error-icon {
  color: #ef4444;
  font-size: 20px;
  margin-right: 8px;
}

.error-title {
  color: #dc2626;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.erro-details p {
  color: #991b1b;
  margin: 0 0 12px 0;
  font-size: 14px;
}

.erro-content {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 12px;
  max-height: 200px;
  overflow-y: auto;
}

.erro-content pre {
  background: transparent;
  margin: 0;
  padding: 0;
  font-size: 12px;
  color: #374151;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Responsive */
@media (max-width: 576px) {
  .acoes-boleto {
    flex-direction: column;
  }

  .btn-gerar-boleto {
    padding: 12px 20px;
    font-size: 14px;
  }

  .btn-acao {
    padding: 8px 12px;
    font-size: 13px;
  }
}

/* Modal Override */
.boleto-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
}

.boleto-modal >>> .modal-body {
  padding: 20px;
}
</style>